<template>
  <k-modal id="view-all-project-feedback-modal" :show="showModal"
    @close="onClose"
    :closeOnClickAway="false"
  >
    <template #header>
      <h3>{{ modalTitle }}</h3>
    </template>
    <template #body>
      <notes-overview
        v-if="projectId"
        :filterable="true"
        :is-project-feedback="true"
        :is-learner-support="false"
        :use-custom-notes="true"
        :custom-notes="projectFeedback"
        @custom-get-notes="getFeedback"
        >
        <template #tags="{ note }">
          <k-tooltip text="Project phase at time of feedback" position="right">
            <div class="tags">
              <span v-if="note && note.project_phase" :class="note.project_phase.toLowerCase()">{{ note.project_phase }}</span>
            </div>
          </k-tooltip>
        </template>
      </notes-overview>
    </template>
  </k-modal>
</template>

<style scoped>
  .scoping,
  .general,
  .completed,
  .evidence {
    color: var(--kate-type-dark);
  }

  .scoping {
    background-color: var(--kate-logo-purple);
  }

  .general {
    background-color: var(--kate-type-blue);
  }

  .completed {
    background-color: var(--kate-success);
  }

  .evidence {
    background-color: var(--kate-type-blue);
  }

  .scoping::before,
  .general::before,
  .completed::before,
  .evidence::before {
    border-color: transparent var(--current-color) transparent transparent;
  }

  .scoping::before { --current-color: var(--kate-logo-purple); }
  .general::before { --current-color: var(--kate-type-blue); }
  .completed::before { --current-color: var(--kate-success); }
  .evidence::before { --current-color: var(--kate-type-blue); }
</style>

<script>
import KModal from '@base-components/k-modal.vue';
import KTooltip from '@base-components/k-tooltip.vue';
import NotesOverview from '../../dashboard/student/notes-overview.vue';

export default {
  components: {
    KModal,
    NotesOverview,
    KTooltip,
  },

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },

    programmeId: {
      type: Number,
      required: true,
    },

    projectId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {

      modalTitle: 'Project Feedback',
      projectFeedback: [],

    };
  },

  methods: {
    getFeedback() {
      this.$Loading.minimal();
      this.$logger.info('Getting project feedback', { projectId: this.projectId }, true);

      return this.$http.get(`/api/curriculum/programmes/${this.programmeId}/projects/${this.projectId}/feedback`)
        .then(result => this.formatFeedbackToNotes(result.data))
        .then(feedback => {
          this.projectFeedback = feedback;
          this.$logger.info('Got project feedback', { projectId: this.projectId });
        })
        .catch(error => {
          this.$logger.error('Error fetching project feedback', { projectId: this.projectId }, error);
          this.$ktoast.showError(error, true);
          this.projectFeedback = [];
        })
        .finally(() => {
          this.$Loading.finish();
        });
    },

    onClose() {
      this.$emit('close');
    },

    formatFeedbackToNotes(feedback) {
      if (!Array.isArray(feedback) || feedback.length === 0) {
        return [];
      }

      const userIds = [...new Set(feedback.map(f => f.author_user_id))];

      const authorNames = {};
      const namePromises = userIds.map(userId => this.$http.get(`/api/profile/users/${userId}`)
        .then(res => {
          authorNames[userId] = res.data.full_name;
        })
        .catch(() => {
          authorNames[userId] = 'Mentor';
        }));

      // Wait for all name requests to complete, then transform feedback
      return Promise.all(namePromises).then(() => feedback.map(feedbackItem => ({
        note_id: feedbackItem.id,
        programme_member_id: null,
        note: feedbackItem.feedback_text,
        date_created: feedbackItem.created_at,
        date_updated: null,
        author_user_id: feedbackItem.author_user_id,
        author_name: authorNames[feedbackItem.author_user_id],
        share_with_employer: false,
        source: 'project_feedback',
        project_phase: this.formatProjectPhase(feedbackItem.project_phase_at_feedback),
      })));
    },

    formatProjectPhase(phase) {
      return phase.charAt(0).toUpperCase() + phase.slice(1);
    },
  },
};
</script>
